type MailToProps = {
  to: string;
};

const MailTo: React.FunctionComponent<MailToProps> = ({to}) => {
	return <a href={`mailto:${to}`}>{to}</a>;
};

export default MailTo;